import { clearAccessToken } from "./token"

const PREFIX = "openanalyst_auth_"
const RETURN_TO_KEY = `${PREFIX}return_to`
const SESSION_TOKEN_KEY = "x-session-token"
const AUTH_BROADCAST_CHANNEL = "openanalyst-auth"

function session() {
  if (typeof sessionStorage === "undefined") return
  return sessionStorage
}

export function storeReturnTo(url: string): void {
  session()?.setItem(RETURN_TO_KEY, url)
}

export function getReturnTo(): string | null {
  return session()?.getItem(RETURN_TO_KEY) ?? null
}

export function clearReturnTo(): void {
  session()?.removeItem(RETURN_TO_KEY)
}

export function setSessionToken(token: string): void {
  session()?.setItem(SESSION_TOKEN_KEY, token)
}

export function getSessionToken(): string | null {
  return session()?.getItem(SESSION_TOKEN_KEY) ?? null
}

export function clearSessionToken(): void {
  session()?.removeItem(SESSION_TOKEN_KEY)
}

function clearPersistedData(): void {
  if (typeof localStorage === "undefined") return
  const keysToRemove: string[] = []
  for (let i = 0; i < localStorage.length; i++) {
    const key = localStorage.key(i)
    if (key && key.startsWith("openanalyst.")) keysToRemove.push(key)
  }
  for (const key of keysToRemove) {
    localStorage.removeItem(key)
  }
}

export function clearAllAuthData(): void {
  clearReturnTo()
  clearSessionToken()
  clearAccessToken()
  clearPersistedData()
}

export function broadcastLogout(): void {
  if (typeof BroadcastChannel === "undefined") return
  const channel = new BroadcastChannel(AUTH_BROADCAST_CHANNEL)
  channel.postMessage({ type: "logout" })
  channel.close()
}

export function onLogoutBroadcast(callback: () => void): () => void {
  if (typeof BroadcastChannel === "undefined") return () => {}
  const channel = new BroadcastChannel(AUTH_BROADCAST_CHANNEL)
  const handler = (event: MessageEvent<{ type?: string }>) => {
    if (event.data?.type !== "logout") return
    callback()
  }
  channel.addEventListener("message", handler)
  return () => {
    channel.removeEventListener("message", handler)
    channel.close()
  }
}
